import React, { useRef, useState } from 'react';
import { Chip, Popper, Fade } from '@material-ui/core';
import { BaseSelect } from './BaseSelect';
import { makeStyles } from '@material-ui/styles';

export const groupingOptions = [
    {
        id: 'user',
        title: 'User',
    },
    {
        id: 'website',
        title: 'Website',
    },
];

const useStyles = makeStyles(theme => ({
    popper: {
        zIndex: 1500,
    },
    root: {
        position: 'relative',
        display: 'inline-block',
    },
}));

const GroupByFilter = ({
    onChange = () => {},
    onClick = () => {},
    onClose = () => {},
    selected = groupingOptions[0],
    open = false,
    anchorEl = null,
}) => {
    const classes = useStyles();
    const anchorRef = useRef(null);
    const [opened, setOpened] = useState(open);
    const [type, setType] = useState(selected);

    const handleToggle = () => {
        setOpened(prevOpen => !prevOpen);
        onClick();
    };

    const handleClose = event => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpened(false);
        onClose();
    };

    const handleChangeType = (event, typeOption) => {
        setType(typeOption);
        handleClose(event);
        onChange(typeOption);
    };

    return (
        <div className={classes.root}>
            <Chip
                ref={anchorRef}
                label={`Group by: ${type.title}`}
                color="secondary"
                onClick={handleToggle}
                style={{ marginRight: 5 }}
            />
            <Popper
                open={opened}
                anchorEl={() => anchorRef.current}
                transition
                placement="bottom-end"
                className={classes.popper}
            >
                {({ TransitionProps }) => (
                    <Fade {...TransitionProps}>
                        <BaseSelect
                            onClose={handleClose}
                            onChange={handleChangeType}
                            options={groupingOptions}
                        />
                    </Fade>
                )}
            </Popper>
        </div>
    );
};

export { GroupByFilter };
